var map = {
	"./AdaIDE.dark.png": 8005,
	"./AdaIDE.darkplus.png": 6921,
	"./AdaIDE.default.png": 7730,
	"./AdaIDE.onedark.png": 3389,
	"./AdaIDE.pink.png": 3309,
	"./AdaIDE.real-dark.png": 6136,
	"./AndroidJavaIDE.dark.png": 1008,
	"./AndroidJavaIDE.darkplus.png": 2080,
	"./AndroidJavaIDE.default.png": 2597,
	"./AndroidJavaIDE.onedark.png": 6445,
	"./AndroidJavaIDE.pink.png": 5768,
	"./AndroidJavaIDE.real-dark.png": 5467,
	"./AndroidKotlinIDE.dark.png": 3695,
	"./AndroidKotlinIDE.darkplus.png": 8431,
	"./AndroidKotlinIDE.default.png": 9775,
	"./AndroidKotlinIDE.onedark.png": 2363,
	"./AndroidKotlinIDE.pink.png": 367,
	"./AndroidKotlinIDE.real-dark.png": 4154,
	"./CCmake.dark.png": 1253,
	"./CCmake.darkplus.png": 5849,
	"./CCmake.default.png": 578,
	"./CCmake.onedark.png": 4557,
	"./CCmake.pink.png": 9981,
	"./CCmake.real-dark.png": 6792,
	"./DiffofTwoCompilers.dark.png": 1323,
	"./DiffofTwoCompilers.darkplus.png": 939,
	"./DiffofTwoCompilers.default.png": 6200,
	"./DiffofTwoCompilers.onedark.png": 7271,
	"./DiffofTwoCompilers.pink.png": 5211,
	"./DiffofTwoCompilers.real-dark.png": 8774,
	"./DiffofTwoSources.dark.png": 8387,
	"./DiffofTwoSources.darkplus.png": 4355,
	"./DiffofTwoSources.default.png": 8640,
	"./DiffofTwoSources.onedark.png": 5199,
	"./DiffofTwoSources.pink.png": 4899,
	"./DiffofTwoSources.real-dark.png": 3678,
	"./JavaIDE.dark.png": 4769,
	"./JavaIDE.darkplus.png": 197,
	"./JavaIDE.default.png": 5726,
	"./JavaIDE.onedark.png": 9289,
	"./JavaIDE.pink.png": 6345,
	"./JavaIDE.real-dark.png": 2836,
	"./LLVMIR.dark.png": 435,
	"./LLVMIR.darkplus.png": 9603,
	"./LLVMIR.default.png": 5424,
	"./LLVMIR.onedark.png": 5951,
	"./LLVMIR.pink.png": 2323,
	"./LLVMIR.real-dark.png": 462,
	"./PascalIDE.dark.png": 5549,
	"./PascalIDE.darkplus.png": 2529,
	"./PascalIDE.default.png": 730,
	"./PascalIDE.onedark.png": 2293,
	"./PascalIDE.pink.png": 8501,
	"./PascalIDE.real-dark.png": 4128,
	"./Preprocessor.dark.png": 6502,
	"./Preprocessor.darkplus.png": 7626,
	"./Preprocessor.default.png": 2595,
	"./Preprocessor.onedark.png": 7988,
	"./Preprocessor.pink.png": 7158,
	"./Preprocessor.real-dark.png": 9953
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4906;